export const FeatureFlag = {
  DomainsDetails: 'domains-details',
  SeoReport: 'seo-report',
  DomainSchedulerSettings: 'domain-scheduler-settings',
  DisableClearCache: 'disable-clear-cache',
  Oversight: 'oversight',
  AccountDetails: 'account-details',
  CustomDeal: 'custom-deal',
  SeoAudit: 'seo-audit',
  DashboardV3: 'dashboard-v3',
  Pricing2025: 'pricing-2025',
  SearchPerformance: 'search-performance',
  AiInsightsBlock: 'ai-insights-block',
  RenderProof: 'render-proof',
  CloudflareBeta: 'cloudflare-beta',
  // The kill switch for the Cloudflare beta (PRE-3294 / AC 8). Where it is
  // present the beta is closed, staff included. It belongs in this catalogue
  // like every other flag: a bare literal is a flag nobody can find, and the
  // value has to match `CF_BETA_BLOCK_FEATURE` in `@prerender/prerender-shared`
  // — `cloudflareBetaAccess.ts` re-exports that one rather than repeating it.
  CloudflareBetaBlock: 'cloudflare-beta-block',
  AiInsightsAmazonbot: 'ai-insights-amazonbot',
  CrawlerCategoriesNoGemini: 'crawler-categories-no-gemini',
} as const;

export type FeatureFlagValue = typeof FeatureFlag[keyof typeof FeatureFlag];
